// extracted by mini-css-extract-plugin
var _1 = "CarouselSliderButton-module__animateUploadProgressBarWidth--V2tRb";
var _2 = "CarouselSliderButton-module__animatedBackground--_97sw";
var _3 = "CarouselSliderButton-module__button--oPH6e";
var _4 = "CarouselSliderButton-module__img--oHWje";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button", _4 as "img" }
